export default __webpack_public_path__ + "static/media/ars.664354ce.svg";